// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Prevent double-tap zoom on all elements */
* {
  touch-action: manipulation;
}

/* Prevent text selection and improve touch experience */
body {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  user-select: none;
  -webkit-tap-highlight-color: transparent;
  margin: 0;
  overflow: hidden; /* Prevent scrolling */
}

/* Scale entire app to fit viewport */
html, body, #root {
  width: 100%;
  height: 100%;
}

/* Use viewport units for responsive scaling */
#root {
  font-size: min(2vw, 2vh); /* Base font size scales with viewport */
}

.App {
  text-align: center;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,4CAA4C;AAC5C;EACE,0BAA0B;AAC5B;;AAEA,wDAAwD;AACxD;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,iBAAiB;EACjB,wCAAwC;EACxC,SAAS;EACT,gBAAgB,EAAE,sBAAsB;AAC1C;;AAEA,qCAAqC;AACrC;EACE,WAAW;EACX,YAAY;AACd;;AAEA,8CAA8C;AAC9C;EACE,wBAAwB,EAAE,wCAAwC;AACpE;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF","sourcesContent":["/* Prevent double-tap zoom on all elements */\n* {\n  touch-action: manipulation;\n}\n\n/* Prevent text selection and improve touch experience */\nbody {\n  -webkit-touch-callout: none;\n  -webkit-user-select: none;\n  user-select: none;\n  -webkit-tap-highlight-color: transparent;\n  margin: 0;\n  overflow: hidden; /* Prevent scrolling */\n}\n\n/* Scale entire app to fit viewport */\nhtml, body, #root {\n  width: 100%;\n  height: 100%;\n}\n\n/* Use viewport units for responsive scaling */\n#root {\n  font-size: min(2vw, 2vh); /* Base font size scales with viewport */\n}\n\n.App {\n  text-align: center;\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
